const Header = (state = {}, action) => {
  switch (action.type) {
    case 'CLEARALL': {
      return {};
    }
    default: {
      return state;
    }
  }
};

export default Header;
